import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import "./Style/common.css";
import "../STUDENT/MSR/Style/StudyRoom.css";
import trophy_club_0 from './trophy_club/trophy_club_0.png';
import trophy_club_10 from './trophy_club/trophy_club_10.png';
import trophy_club_25 from './trophy_club/trophy_club_25.png';
import trophy_club_50 from './trophy_club/trophy_club_50.png';
import trophy_club_75 from './trophy_club/trophy_club_75.png';
import trophy_club_100 from './trophy_club/trophy_club_100.png';
import trophy_club_150 from './trophy_club/trophy_club_150.png';
import trophy_club_200 from './trophy_club/trophy_club_200.png';
import trophy_club_250 from './trophy_club/trophy_club_250.png';
import trophy_club_300 from './trophy_club/trophy_club_300.png';
import trophy_club_350 from './trophy_club/trophy_club_350.png';
import trophy_club_400 from './trophy_club/trophy_club_400.png';

interface TrophyRange {
  totalTrophyCount: number;
  min: number;
  max?: number;
  points: number;
}

const Section: React.FC = () => {
  const [isLegendVisible, setIsLegendVisible] = useState(false);
  const [
    // userName
    , setUserName] = useState<string>("");
  const [totalTrophyCount, setTotalTrophyCount] = useState<number>(0);
  const initialPoints = Number(sessionStorage.getItem("CurrentPoints") || "0");
  const [currentPoints, setCurrentPoints] = useState<number>(initialPoints);
  const [displayedPoints, setDisplayedPoints] = useState<number>(initialPoints);
  const displayedPointsRef = useRef(initialPoints);
  const [
    // imageSrc
    , setImageSrc] = useState('');
  const [M_plan, setMPlan] = useState(() => sessionStorage.getItem("Maths_wlp_plan"));
  const [E_plan, setEPlan] = useState(() => sessionStorage.getItem("English_wlp_plan"));
  const location = useLocation();
  const apiUrl = process.env.REACT_APP_DOCUMENT_LINK;

  const hiddenPaths = [
    "/STUDENT/MSR/MyStore",
    "/STUDENT/MSR/MyIncentives",
    "/STUDENT/MSR/MyCompsCurrent",
    "/STUDENT/MSR/MyCompsPast",
    "/STUDENT/MSR/AllPurchases"
  ];

  const weeklyProgress = sessionStorage.getItem("WeeklyProgress");
  const formattedPoints = displayedPoints.toLocaleString('en-US');

  const S_plan = sessionStorage.getItem("Science_wlp_plan");


  const trophyImages = [
    trophy_club_0,
    trophy_club_10,
    trophy_club_25,
    trophy_club_50,
    trophy_club_75,
    trophy_club_100,
    trophy_club_150,
    trophy_club_200,
    trophy_club_250,
    trophy_club_300,
    trophy_club_350,
    trophy_club_400,
  ];

  const trophyRanges: TrophyRange[] = [
    { min: 0, max: 9, points: 500, totalTrophyCount: totalTrophyCount },
    { min: 10, max: 24, points: 750, totalTrophyCount: totalTrophyCount },
    { min: 25, max: 49, points: 1000, totalTrophyCount: totalTrophyCount },
    { min: 50, max: 74, points: 1250, totalTrophyCount: totalTrophyCount },
    { min: 75, max: 99, points: 1500, totalTrophyCount: totalTrophyCount },
    { min: 100, max: 149, points: 2000, totalTrophyCount: totalTrophyCount },
    { min: 150, max: 199, points: 2500, totalTrophyCount: totalTrophyCount },
    { min: 200, max: 249, points: 3000, totalTrophyCount: totalTrophyCount },
    { min: 250, max: 299, points: 3500, totalTrophyCount: totalTrophyCount },
    { min: 300, max: 349, points: 4000, totalTrophyCount: totalTrophyCount },
    { min: 350, max: 399, points: 4500, totalTrophyCount: totalTrophyCount },
    { min: 400, max: undefined, points: 5000, totalTrophyCount: totalTrophyCount }
  ];

  const normalizeSubject = (value: string | null | undefined): string => {
    const subject = value?.trim();
    if (!subject) return "";

    const normalized = subject.toLowerCase();
    if (normalized === "maths" || normalized === "mathematics") return "Mathematics";
    if (normalized === "english" || normalized === "eng") return "English";
    return subject;
  };

  const subject = normalizeSubject(sessionStorage.getItem("Subject"));

  const plan = subject === "Mathematics" ? "Maths" : subject;

  const selectedRangeIndex = trophyRanges.findIndex(range => {
    if (range.max === undefined) {
      return totalTrophyCount >= range.min;
    }
    return totalTrophyCount >= range.min && totalTrophyCount <= range.max!;
  });

  const calculateProgress = (): number => {
    const currentRange = trophyRanges[selectedRangeIndex];
    const nextRange = trophyRanges[selectedRangeIndex + 1];

    if (!nextRange || selectedRangeIndex === trophyRanges.length - 1) {
      return 100;
    }

    const rangeSize = currentRange.max! - currentRange.min + 1;
    const progress = ((totalTrophyCount - currentRange.min) / rangeSize) * 100;
    return Math.round(progress);
  };

  const calculateRemainingTrophies = (): number => {
    const nextRange = trophyRanges[selectedRangeIndex + 1];

    if (!nextRange || selectedRangeIndex === trophyRanges.length - 1) {
      return 0;
    }

    return nextRange.min - totalTrophyCount;
  };

  const handleTrophyClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsLegendVisible((prev) => !prev);
  };

  useEffect(() => {
    const updateUserData = () => {
      const UserName = sessionStorage.getItem('FName');
      const UserAvatar = sessionStorage.getItem('CurrentAvatar');
      const TotalTrophyCount = sessionStorage.getItem("TotalTrophyCount");

      if (UserName !== null) {
        setUserName(UserName);
      }

      if (UserAvatar) {
        setImageSrc(UserAvatar);
      }

      if (TotalTrophyCount) {
        setTotalTrophyCount(Number(TotalTrophyCount));
      }
      const CurrentPoints = sessionStorage.getItem("CurrentPoints");
      if (CurrentPoints) {
        setCurrentPoints(Number(CurrentPoints));
      }
    };

    const handlePointsUpdated = () => {
      const points = Number(sessionStorage.getItem("CurrentPoints") || "0");
      setCurrentPoints(points);
    };

    const handleTrophyStatusUpdated = () => {
      const trophies = Number(sessionStorage.getItem("TotalTrophyCount") || "0");
      setTotalTrophyCount(trophies);
    };

    // Initial load
    updateUserData();

    // Apply background
    document.body.classList.add('StudyRoom-background');

    // Listen for sessionStorage changes
    window.addEventListener("storage", updateUserData);
    window.addEventListener("pointsUpdated", handlePointsUpdated);
    window.addEventListener("trophyStatusUpdated", handleTrophyStatusUpdated);

    return () => {
      document.body.classList.remove('StudyRoom-background');
      window.removeEventListener("storage", updateUserData);
      window.removeEventListener("pointsUpdated", handlePointsUpdated);
      window.removeEventListener("trophyStatusUpdated", handleTrophyStatusUpdated);
    };
  }, []);

  useEffect(() => {
    const updateWeeklyPlans = () => {
      setMPlan(sessionStorage.getItem("Maths_wlp_plan"));
      setEPlan(sessionStorage.getItem("English_wlp_plan"));
    };

    window.addEventListener("weeklyPlansUpdated", updateWeeklyPlans);
    return () => window.removeEventListener("weeklyPlansUpdated", updateWeeklyPlans);
  }, []);

  useEffect(() => {
    const startValue = displayedPointsRef.current;
    const endValue = currentPoints;

    if (startValue === endValue) return;

    const duration = 2000;
    const startedAt = performance.now();
    let animationFrame = 0;

    const animate = (timestamp: number) => {
      const progress = Math.min((timestamp - startedAt) / duration, 1);
      const nextValue = Math.floor(
        startValue + (endValue - startValue) * progress
      );

      displayedPointsRef.current = nextValue;
      setDisplayedPoints(nextValue);

      if (progress < 1) {
        animationFrame = requestAnimationFrame(animate);
      }
    };

    animationFrame = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(animationFrame);
  }, [currentPoints]);

  useEffect(() => {
    const refreshPoints = async () => {
      const schoolCode = sessionStorage.getItem("SchoolCode");
      const familyCode = sessionStorage.getItem("FamilyCode");
      const login = sessionStorage.getItem("Login");

      if (!schoolCode || !familyCode || !login) return;

      try {
        const lastPage = new URLSearchParams(location.search).get("lastPage");
        if (
          lastPage === "Result" &&
          location.pathname.includes("/ExploreActivities")
        ) {
          await fetch(`${apiUrl}clear_cache/`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              SchoolCode: schoolCode,
              FamilyCode: familyCode,
              Login: login,
              Caches: ["all_user"],
            }),
          });
        }

        const response = await fetch(`${apiUrl}totalTrophyCount_Points/`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            SchoolCode: schoolCode,
            FamilyCode: familyCode,
            Login: login,
          }),
        });
        const data = await response.json();

        if (!response.ok || !data) return;

        if (data.currentpoints != null) {
          const points = Number(data.currentpoints);
          sessionStorage.setItem("CurrentPoints", points.toString());
          setCurrentPoints(points);
        }
        if (data.totaltrophycount != null) {
          const trophies = Number(data.totaltrophycount);
          sessionStorage.setItem("TotalTrophyCount", trophies.toString());
          setTotalTrophyCount(trophies);
        }
      } catch (error) {
        console.error("Error refreshing Section points:", error);
      }
    };

    refreshPoints();
  }, [apiUrl, location.pathname, location.search]);

  useEffect(() => {
    const handleClickOutside = () => {
      setIsLegendVisible(false);
    };

    if (isLegendVisible) {
      document.addEventListener('click', handleClickOutside);
    }

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isLegendVisible]);

  const image = sessionStorage.getItem('CurrentAvatar');

  return (
    <div id="user_banner" className='user_bannerT' style={{ height: '80px', paddingTop:"8px", paddingBottom:"88px" }}>
      <div className="section_div">
        <div id="achievements_btn">
          <a href="Section">ACHIEVEMENTS</a>
        </div>
        <div id="user_strip_right_container">
          <div id="divAvatarContainer" className="avatar_container">
            <img id="imgAvatar" src={image?.toString() ?? ''} alt="Avatar" />
          </div>
          <div id="trophy_club_container">
            <div id="trophy_club_section">
              <p className="trophy_club_section_title">CLUB</p>
              <div
                id="trophy_club_current"
                onClick={handleTrophyClick}
                className='trophy_club_currentT'
                style={{ backgroundImage: `url(${trophyImages[selectedRangeIndex]})` }}
              ></div>
              <div
                id="trophy_club_legend"
                className={`trophy_club_legendT ${isLegendVisible ? 'is-visible' : ''}`}
                onClick={(e) => e.stopPropagation()}
              >
                <p className="trophy_club_legend_title">TROPHY CLUB</p>
                <div id="trophy_club_progress_container">
                  <div id="trophy_club_progress_trophy_current" className="trophy_club_progress_trophy" style={{ backgroundImage: `url(${trophyImages[selectedRangeIndex]})` }}></div>
                  {/* <div id=""className="trophy_club_progress_trophy"></div> */}


                  <div id="trophy_club_progress_bar_div">
                    <div
                      id="trophy_club_progress_bar_div_progress"
                      style={{ width: `${calculateProgress()}%` }}
                      className="trophy-progress-barT"
                    />
                    <div
                      className="trophy-progress-arrow"
                      style={{ left: `calc(${calculateProgress()}% - 5px)` }}
                    />
                  </div>
                  <div id="trophy_club_progress_trophy_next" className="trophy_club_progress_trophy" style={{ backgroundImage: `url(${trophyImages[selectedRangeIndex + 1]})` }}></div>
                </div>
                <p className="trophy_club_legend_text">
                  <span id="next_club">{calculateRemainingTrophies()} more trophies to next club</span>
                </p>
                <div className="trophy_club_legend_spacing"></div>
                <table id="trophy_club_legend_spacing_table">
                  <thead>
                    <tr>
                      <th className="tfr">CLUB</th>
                      <th className="tsr">TROPHY<br />TOTAL</th>
                      <th>BONUS<br />POINTS</th>
                    </tr>
                  </thead>
                  <tbody>
                    {trophyRanges.map((range, index) => {
                      const isSelected = index === selectedRangeIndex;
                      const rangeText = range.max === undefined
                        ? `${range.min}+`
                        : `${range.min} - ${range.max}`;

                      return (
                        <tr key={index} className={`legend_trophy_row${isSelected ? '_selected' : ''}`}>
                          <td className="tfr">
                            {isSelected && <div id="trophy_legend_marker"></div>}
                            <span
                              id={`legend_trophy_icon_${String(index + 1).padStart(2, '0')}`}
                              className="legend_trophy_icon"
                            />
                          </td>
                          <td className="tsr">{rangeText}</td>
                          <td>{range.points.toLocaleString('en-IN')}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div id="my_points_container">
            <div id="my_points_text">MY POINTS</div>
            <label id="lblMyPoints" className="my_points_amount my_points_amountT">{formattedPoints}</label>
          </div>

          <div className='ump_btnT'>
            <div id="ump_btn">
              {hiddenPaths.includes(location.pathname) ?<a href="/STUDENT/MSR/StudyRoom" id="hlinkStudyRoomMobile">Home</a>:<a href="/STUDENT/MSR/MyStore" id="linkbtnUseMyPoints">USE MY POINTS</a>}
            </div>
          </div>
        </div>

        <div id="user_strip_left_container">
          <div id="user_strip_weekly_progress_container">
            <div id="user_strip_weekly_progress_text" style={{
              fontFamily: 'Open Sans, Arial',
              height: '12px',
              padding: '0',
              marginRight: '5px',
              fontSize: '12px',
              fontWeight: 'bold',
              lineHeight: '12px',
              color: '#FFF',
              float: 'left',
              display: 'inline-block'
            }}>
              OVERALL WEEKLY PROGRESS:
              <span id="lblOverAllWeeklyProgress"> {weeklyProgress}</span>%
            </div>
            <div id="user_strip_weekly_progress_bar">
              <div
                id="user_strip_weekly_progress_bar_progress"
                className="user_strip_weekly_progress_bar_progress"
                style={{ width: `${weeklyProgress}%` }}
              ></div>
            </div>
          </div>

          <div id="user_strip_weekly_achievements_container">
            <div id="user_strip_weekly_achievements_text">
              WEEKLY ACHIEVEMENTS:
            </div>
            {M_plan && (
              <div id={`div${M_plan}TrophyContainer`} className="user_strip_weekly_achievements_item" style={{ display: "block" }}>
                <div id={`div${M_plan}Trophy`} className={`trophy ${sessionStorage.getItem("Maths_wlp_status") === "C" ? "trophy_gold" : ""}`}></div>
                <div className="trophy_text">
                  <span id="spnMathOrMathsPlan">{M_plan}</span>
                </div>
              </div>
            )}
            {E_plan && (
              <div id={`div${E_plan}TrophyContainer`} className="user_strip_weekly_achievements_item" style={{ display: "block" }}>
                <div id={`div${E_plan}Trophy`} className={`trophy ${sessionStorage.getItem("English_wlp_status") === "C" ? "trophy_gold" : ""}`}></div>
                <div className="trophy_text">
                  <span id="spnMathOrMathsPlan">{E_plan}</span>
                </div>
              </div>
            )}

            <div className="user_strip_weekly_achievements_item">
              <div className="trophy_text">
                <span className="trophy_total_slash">/&nbsp;&nbsp;</span>TOTAL:&nbsp;&nbsp;
              </div>
              <div className="trophy trophy_gold"></div>
              <div className="trophy_text">x&nbsp;
                <span id="spnTrophyText">{totalTrophyCount}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section;
